import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { LocationDropdown, ProgressBar } from "components";
import {
  AccountDropdown,
  AppointmentsButton,
  DayplannerPageButton,
  DealerDocsButton,
  ManufacturerNotifications,
  NotificationsBellButton,
  RefetchButton,
  Sidebar,
  SupportButton
} from "components/NavBar/components";
import { useHideDealerLocationsDropdown } from "components/NavBar/hooks";
import "components/NavBar/NavBar.scss";
import { getRouteProperties } from "components/NavBar/routes";
import { usePermanentSession } from "modules/Login/hooks";

type NavBarProps = {
  openSidebar: () => void;
};

export const NavBar = ({ openSidebar }: NavBarProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const { session } = usePermanentSession();
  const hideDealerLocationsDropdowns = useHideDealerLocationsDropdown();

  return (
    <div className={`nav-bar-wrapper ${getRouteProperties(t, location).defaultClassname}`}>
      <div className="nav-bar-content">
        <ProgressBar />
        <Sidebar openSidebar={openSidebar} />
        <div id="navbar-portal-container" />

        <div className="nav-bar-start">
          {!session?.appointment_id && (
            <>
              {!hideDealerLocationsDropdowns && <LocationDropdown />}
              <RefetchButton />
              <DealerDocsButton />
              <SupportButton />
              <DayplannerPageButton />
              <AppointmentsButton />
              <ManufacturerNotifications />
              <NotificationsBellButton />
              <AccountDropdown />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
